module.exports = __webpack_public_path__ + "img/logo_NU.3771a543.png";